import React, { Component } from 'react'
import ListLists from '../../Services/Queries/ListLists'
import AddListToPeopleService from '../../Services/Mutations/AddListToPeopleService'
import { Auth } from 'aws-amplify'
import { Button, Modal } from 'react-bootstrap'

class AddList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      searchQuery: '',
      listOfLists: [],
      limit: 20,
      nextToken: null,
      endReached: false,
      spinner: true,
      selectedList: {},
      modalVisible: false,
      sectionLabel_Te: '',
      sectionLabel_Hi: '',
      sectionLabel_En: '',
      isMainList: false,
      sortType: 'date',
      selectedSectionColumns: '1',
      selectedSectionScroll: 'horizontal',
      addingNewItemsTo: 0,
      showAsSubPage: false,
      showAfter: '',
    }
    this.sectionColumns = [1, 2]
    this.sectionScroll = ['horizontal', 'vertical']
    this.sectionLabelLanguages = ['Te', 'Hi', 'En']
  }
  getListLists = async (searchQuery) => {
    const input = {
      limit: this.state.limit,
      appInfoFrontEnd: {
        appVersionNumber: 60,
        UUID: Auth.user.username,
      },
    }
    if (searchQuery) {
      input.search = searchQuery
    }
    console.log(input, 'input')
    const data = await ListLists(input)
    console.log(data, 'data')

    this.setState({
      listOfLists: data.items,
      nextToken: data.nextToken,
      spinner: false,
      endReached: data.nextToken != null ? false : true,
    })
  }
  onChangeSearch = (searchQuery) => {
    this.setState({ searchQuery: searchQuery })
    this.getListLists(searchQuery)
  }
  async componentDidMount() {
    if (this.props.selectedTab == 'Lists') {
      this.getListLists()
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.selectedTab != this.props.selectedTab && this.props.selectedTab == 'Lists') {
      this.setState({ searchQuery: '' })

      this.getListLists()
    }
  }
  buttonVisibilityFunc = () => {
    return Object.keys(this.state.selectedList).length
  }
  getMoreLists = async () => {
    const { endReached, limit, nextToken } = this.state
    if (!endReached) {
      const input = {
        limit: limit,
        nextToken: nextToken,
        appInfoFrontEnd: {
          appVersionNumber: 60,
          UUID: Auth.user.username,
        },
      }
      const data = await ListLists(input)
      this.setState({
        listOfLists: [...this.state.listOfLists, ...data.items],
        nextToken: data.nextToken,
        endReached: data.nextToken != null ? false : true,
      })
    }
  }
  selectList = (selectedList) => {
    this.setState({ selectedList: selectedList })
  }
  buttonVisibilityFunc2 = () => {
    return this.hasSectionlabelError()
  }
  addList = async () => {
    this.setState({ spinner: true })
    const input = {
      listValue: this.state.selectedList,
      sectionPosition: this.props.sectionPosition,
      sectionLabel_Te: this.state.sectionLabel_Te,
      sectionLabel_En: this.state.sectionLabel_En,
      sectionLabel_Hi: this.state.sectionLabel_Hi,
      sectionType: 'list',
    }
    let data
    if (this.props.type == 'people') {
      input.peopleValue = this.props.peopleValue
      input.sortBy = this.state.sortType
      input.sectionColumns = this.state.selectedSectionColumns
      input.sectionScroll = this.state.selectedSectionScroll
      input.displayAfter = parseInt(this.state.showAfter)
      input.showAsSubPage = this.state.showAsSubPage
      input.sectionConfigType = this.state.isMainList ? 'mainList' : 'NO'
      // data = await AddListToPeopleService(input)
    }
    // console.log(data, 'list to peopleeeeeeeeee data')
    this.setState({ modalVisible: false })
    this.props.addPeopleSections(input)

    this.props.closeListCollectionModal()
    // const data = await AddListToPeopleService(input)
    // if (data.statusCode == 'A258') {
    //   this.setState({ modalVisible: false, spinner: false }, () => {
    //     this.props.navigation.goBack()
    //   })
    // } else {
    //   this.setState({ modalVisible: false, spinner: false })
    // }
  }
	getListName = (item) => {

    return item.listName
      ? item.listName
      : item.listName_En
      ? item.listName_En
      : item.listName_Hi
      ? item.listName_Hi
      : item.listName_Te
      ? item.listName_Te
      : item.listName
  }
  _rowRenderer(item) {
    const backgroundColor = this.state.selectedList.listValue == item.listValue ? '#999999' : null
    return (
      <div>
        <div
          style={{ marginBottom: '5px', backgroundColor: backgroundColor }}
          onClick={() => {
            this.selectList(item)
          }}
        >
          <img
            style={{ width: '30px', height: '30px', borderRadius: '20px', marginRight: '5px' }}
            src={item.listThumbnail}
          />
          <text>{this.getListName(item)}</text>
        </div>
      </div>
    )
  }
  loadMore = async () => {
    await this.getMoreLists()
  }
  closeModal = () => {
    this.setState({ modalVisible: false })
  }
  handleHiSectionLabel = (e) => {
    const sectionLabel = e.target.value

    this.setState({ sectionLabel_Hi: sectionLabel })
  }
  handleEnSectionLabel = (e) => {
    const sectionLabel = e.target.value
    this.setState({ sectionLabel_En: sectionLabel })
  }
  handleTeSectionLabel = (e) => {
    const sectionLabel = e.target.value

    this.setState({ sectionLabel_Te: sectionLabel })
  }
  hasSectionlabelError = () => {
    return this.state.sectionLabel_Te || this.state.sectionLabel_En || this.state.sectionLabel_Hi
  }
  handleSortOption = async (sortValue) => {
    const { sortType } = this.state
    if (sortValue != sortType) {
      this.setState({ sortType: sortValue })
    }
  }
  handleShowAfter = (e) => {
    const showAfter = e.target.value
    this.setState({ showAfter })
  }
  toggleMainList = () => {
    this.setState({ isMainList: !this.state.isMainList })
  }
  selectSectionColumn = (sectionColumn) => {
    this.setState({ selectedSectionColumns: sectionColumn })
  }
  selectSectionScroll = (sectionScroll) => {
    this.setState({ selectedSectionScroll: sectionScroll })
  }
  toggleShowAsSubPage = () => {
    this.setState({ showAsSubPage: !this.state.showAsSubPage })
  }

  renderModal = () => {
    const {
      sectionLabel_En,
      sectionLabel_Hi,
      sectionLabel_Te,
      sortType,
      showAfter,
      itemToEdit,
    } = this.state
    return (
      <div>
        <Modal show={this.state.modalVisible} onHide={() => this.closeModal()}>
          <Modal.Body>
            <div>
              <label for='text'>sectionLabel_En</label>
              <div>
                <input
                  type='text'
                  onChange={(e) => {
                    this.handleEnSectionLabel(e)
                  }}
                  value={sectionLabel_En}
                  placeholder='Please Enter sectionLabel_En'
                ></input>
              </div>
            </div>
            <div>
              <label for='text'>sectionLabel_Te</label>
              <div>
                <input
                  type='text'
                  onChange={(e) => {
                    this.handleTeSectionLabel(e)
                  }}
                  value={sectionLabel_Te}
                  placeholder='Please Enter sectionLabel_Te'
                ></input>
              </div>
            </div>
            <div>
              <label for='text'>sectionLabel_Hi</label>
              <div>
                <input
                  type='text'
                  onChange={(e) => {
                    this.handleHiSectionLabel(e)
                  }}
                  value={sectionLabel_Hi}
                  placeholder='Please Enter sectionLabel_Hi'
                ></input>
              </div>
            </div>
            <div>
              <div>
                <text>Sort By</text>
              </div>
              <div>
                <div>
                  <div>
                    <input
                      value={'By DateTime'}
                      type='radio'
                      checked={sortType == 'date'}
                      onChange={() => this.handleSortOption('date')}
                    ></input>
                    <text for={'By DateTime'}>{'By DateTime'}</text>
                  </div>
                  <div>
                    <input
                      value={'By Points'}
                      type='radio'
                      checked={sortType == 'points'}
                      onChange={() => this.handleSortOption('points')}
                    ></input>
                    <text for={'By Points'}>{'By Points'}</text>
                  </div>
                </div>
              </div>
              {console.log(this.state.itemToEdit, 'this.state.itemToEdit')}
              {console.log(this.state.sectionDetails, 'this.state.sectionDetails')}
              <div>
                <div>
                  <div className='custom-control custom-switch'>
                    <input
                      type='checkbox'
                      className='custom-control-input'
                      onChange={() => this.toggleShowAsSubPage()}
                      checked={this.state.showAsSubPage}
                      id='showAsSubPage'
                      readOnly
                    />
                    <label className='custom-control-label' htmlFor='showAsSubPage'>
                      Show As Sub Page
                    </label>
                  </div>
                </div>
              </div>
              <div>
                <div>
                  <div>
                    <text>Section Columns</text>
                    <div>
                      {this.sectionColumns.map((itemType) => {
                        return (
                          <div className='col-md-3'>
                            <input
                              value={itemType}
                              type='radio'
                              checked={this.state.selectedSectionColumns == itemType}
                              onChange={() => this.selectSectionColumn(itemType)}
                            ></input>
                            <text for={itemType}>{itemType}</text>
                          </div>
                        )
                      })}
                    </div>
                  </div>
                  <div>
                    <text>Section Scroll</text>
                    <div>
                      {this.sectionScroll.map((itemType) => {
                        return (
                          <div className='col-md-3'>
                            <input
                              value={itemType}
                              type='radio'
                              checked={this.state.selectedSectionScroll == itemType}
                              onChange={() => this.selectSectionScroll(itemType)}
                            ></input>
                            <text for={itemType}>{itemType}</text>
                          </div>
                        )
                      })}
                    </div>
                  </div>
                  <div>
                    <text>{'Show After Number Of Records'}</text>
                    <div>
                      <input
                        type='text'
                        value={showAfter}
                        onChange={(e) => {
                          this.handleShowAfter(e)
                        }}
                        placeholder='Enter Show After Number Of Records'
                      ></input>
                    </div>
                  </div>
                  <div>
                    <div className='custom-control custom-switch'>
                      <input
                        type='checkbox'
                        className='custom-control-input'
                        onChange={() => this.toggleMainList()}
                        checked={this.state.isMainList}
                        id='isMainList'
                        readOnly
                      />
                      <label className='custom-control-label' htmlFor='isMainList'>
                        Is Main List
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          {!this.hasSectionlabelError() ? (
            <text for='text' style={{ color: 'red', fontSize: 10 }}>
              Please Enter Section Label
            </text>
          ) : null}

          <Modal.Footer>
            {this.buttonVisibilityFunc2() ? (
              <Button onClick={() => this.addList()}>Submit</Button>
            ) : (
              <Button disabled>Submit</Button>
            )}
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
  render() {
    const {
      spinner,
      listOfLists,
      modalVisible,
      sectionLabel_Te,
      sectionLabel_Hi,
      sectionLabel_En,
    } = this.state
    return (
      <div>
        <label for='gsearch'>Search List:</label>
        <input
          type='text'
          onChange={(e) => {
            this.onChangeSearch(e.target.value)
          }}
          value={this.state.searchQuery}
          placeholder='Enter List Name'
        ></input>
        {listOfLists.map((list, index) => {
          return <div>{this._rowRenderer(list)}</div>
        })}
        {this.state.modalVisible ? this.renderModal() : null}

        {this.state.nextToken != null ? (
          <button onClick={() => this.loadMore()}>Load More</button>
        ) : null}
        {this.buttonVisibilityFunc() ? (
          <Button onClick={() => this.setState({ modalVisible: true })}>Continue</Button>
        ) : (
          <Button disabled>Continue</Button>
        )}
      </div>
    )
  }
}
export default AddList
